export const TRIAL_EXPIRED = {
  disabled: {
    title: 'Your account has been disabled',
    description:
      'Please contact your account administrator for more information.',
  },
  plg: {
    title: 'Your trial has ended',
    descriptionCanExtend:
      'Contact us to purchase PolyAI or extend your trial period if you need more time.',
    descriptionCannotExtend:
      'Talk to your sales manager to continue using your workspace.',
    extendButton: 'Extend your trial by 30 days',
    contactButton: 'Contact PolyAI',
  },
  openTable: {
    title: 'Your trial has ended',
    titleScheduled: 'Call is scheduled',
    description:
      'Contact us to purchase PolyAI or extend your trial period if you need more time',
    contactButton: 'Contact PolyAI',
    rescheduleButton: 'Reschedule',
  },
} as const;
